import { ActionMenuWrapper, Crumblist, DropdownMenuItem, TableColumn } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { IHierarchyReportingAccessConfig } from '../../models/IHierarchyReportingAccessConfig';
import { getGroupTypeLabels } from '../../utilities/GroupTypeEnumHelper';
import { ExpandableTableRow } from '../common/ExpandableTableRow';
import { ConnectedGroupAccessOwnersForHierarchyConfig } from './GroupAccessOwnersForHierarchyConfig';

export interface IHierarchyReportingAccessConfigRowProps {
	hrisId: string;
	config: IHierarchyReportingAccessConfig;
	actionOptions: { label: string; action: (config: IHierarchyReportingAccessConfig) => void }[];
}

export class HierarchyReportingAccessConfigRow extends React.PureComponent<
	IHierarchyReportingAccessConfigRowProps,
	{ isExpanded: boolean }
> {
	public state = {
		isExpanded: false,
	};

	public render() {
		const { config, hrisId } = this.props;

		return (
			<ExpandableTableRow
				key={config.hierarchyReportingAccessConfigId}
				onIconClick={() => this.setState({ isExpanded: !this.state.isExpanded })}
				expanded={this.state.isExpanded}
				expandedRowShowLeftBorder={true}
				expandedRowRender={() => (
					<TableColumn colSpan={6}>
						<ConnectedGroupAccessOwnersForHierarchyConfig
							hierarchyReportingAccessConfigId={config.hierarchyReportingAccessConfigId!}
							hierarchyId={config.hierarchyId!}
							hrisId={hrisId}
							profileIds={config.groupAccessProfiles.map((p) => p.profileId)}
						/>
					</TableColumn>
				)}
			>
				<TableColumn>{config.hierarchyName}</TableColumn>
				<TableColumn>{config.userCount}</TableColumn>
				<TableColumn>
					<Crumblist
						data={config.groupAccessProfiles.map((p) => ({
							value: p.profileId,
							displayText: p.name,
						}))}
					/>
				</TableColumn>
				<TableColumn>
					<Crumblist
						data={getGroupTypeLabels(config.scopeGroupTypes).map((g) => ({
							value: g,
							displayText: g,
						}))}
					/>
				</TableColumn>
				<TableColumn>
					<ActionMenuWrapper>
						{this.props.actionOptions.map((o) => {
							return (
								<DropdownMenuItem key={o.label} onClick={() => o.action(config)}>
									{o.label}
								</DropdownMenuItem>
							);
						})}
					</ActionMenuWrapper>
				</TableColumn>
			</ExpandableTableRow>
		);
	}
}
